import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { domainUrl, formBase } from "../../data/dummyData";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

function DataFormViewer() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const { formId } = useParams();

  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [keyRequired, setKeyRequired] = useState(false);
  const [accessKey, setAccessKey] = useState("");
  const [error, setError] = useState("");

  const [location, setLocation] = useState(null);
  

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
    (pos) => {
        setLocation({
        lat: pos.coords.latitude,
        long: pos.coords.longitude,
        });
    },
    (err) => console.warn('Geolocation error:', err)
    );

    fetchForm();
  }, [formId]);

  const fetchForm = async () => {
    try {
      const key = searchParams.get('key');
      const { data } = await axios.post(`${domainUrl}/emy_get_form`, { 
        id:formId,
        lat: location?.lat,
        long: location?.long,
      });

      if (data.success) {
        // console.log(data)
        setForm(data.form);
      } else {
        if (data.reason == 'key_required') {
          setKeyRequired(true);
        } else {
          setError(data.message);
        }
      }
    } catch (err) {
      setError("Failed to load form.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitKey = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${domainUrl}/emy_get_form`, { 
        id:formId, 
        key: accessKey,
        lat: location?.lat,
        long: location?.long, 
      });

      if (data.success) {
        setForm(data.form);
        setKeyRequired(false);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Invalid key or error occurred.");
    } finally {
      setLoading(false);
    }
  };


  // response
  const parsedData = form?.data ? JSON.parse(form.data) : { fields: [] };

  const fieldsRef = useRef([]);
  // const [fields, setFields] = useState([]);

  const renderField = (field, idx) => {

    const fieldName = `field-${idx}`;

    // Append only if not already present
    if (!fieldsRef.current.some(f => f.name === fieldName)) {
      fieldsRef.current.push({ name: fieldName, label: field.label });
    }

    switch (field.type) {
        case 'text':
        case 'email':
        case 'number':
            return (
                <input
                    type={field.type}
                    className="form-control border-0"
                    id={fieldName}
                    placeholder={`Enter ${field.label}`}
                    onChange={(e) => handleChange(fieldName, e.target.value, field.label)}
                />
            );
        case 'textarea':
            return (
                <textarea
                    className="form-control border-0"
                    id={fieldName}
                    placeholder={`Enter ${field.label}`}
                    rows="4"
                    onChange={(e) => handleChange(fieldName, e.target.value, field.label)}
                />
            );
        case 'select':
            return (
                <select
                    className="form-control border-0"
                    id={fieldName}
                    onChange={(e) => handleChange(fieldName, e.target.value, field.label)}
                >
                    <option value="">Select</option>
                    {field.options.map((opt, optIdx) => (
                        <option key={optIdx} value={opt}>{opt}</option>
                    ))}
                </select>
            );
        case 'radio':
            return (
                <div>
                    {field.options.map((opt, optIdx) => (
                        <div key={optIdx} className="form-check text-white">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={fieldName}
                                id={`radio-${idx}-${optIdx}`}
                                value={opt}
                                onChange={(e) => handleChange(fieldName, e.target.value, field.label)}
                            />
                            <label className="form-check-label" htmlFor={`radio-${idx}-${optIdx}`}>
                                {opt}
                            </label>
                        </div>
                    ))}
                </div>
            );
        case 'checkbox':
            return (
                <div>
                    {field.options.map((opt, optIdx) => (
                        <div key={optIdx} className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`checkbox-${idx}-${optIdx}`}
                                value={opt}
                                onChange={(e) => handleCheckboxChange(fieldName, opt, e.target.checked, field.label)}
                            />
                            <label className="form-check-label" htmlFor={`checkbox-${idx}-${optIdx}`}>
                                {opt}
                            </label>
                        </div>
                    ))}
                </div>
            );
        case 'file':
        case 'audio':
        case 'video':
        case 'image':
            return (
              <input
                  type="file"
                  className="form-control border-0"
                  id={fieldName}
                  accept={field.type === 'image' ? 'image/*' :
                          field.type === 'audio' ? 'audio/*' :
                          field.type === 'video' ? 'video/*' : '*'}
                  onChange={(e) => handleChange(fieldName, e.target.files[0], field.label)}
              />
            );
        default:
            return null;
    }
  };

  const [responses, setResponses] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [sError, setSError] = useState("");

  const handleChange = (fieldName, value, label) => {
    setResponses(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  // const handleChange = (name, value, label) => {
  //   setFields(prev => ({
  //       ...prev,
  //       [name]: { label, value }
  //   }));
  // };

  const handleCheckboxChange = (fieldName, value, checked, label) => {
    setResponses(prev => {
      const prevValues = prev[fieldName] || [];
      if (checked) {
        return { ...prev, [fieldName]: [...prevValues, value] };
      } else {
        return { ...prev, [fieldName]: prevValues.filter(v => v !== value) };
      }
    });
  };

  // const handleCheckboxChange = (name, value, checked, label) => {
  //   setFields(prev => {
  //       const existing = prev[name]?.value || [];
  //       let newValue;

  //       if (checked) {
  //           newValue = [...existing, value];
  //       } else {
  //           newValue = existing.filter(item => item !== value);
  //       }

  //       return {
  //           ...prev,
  //           [name]: { label, value: newValue }
  //       };
  //   });
  // };

  // {
  //   "field-0": { label: "Name", value: "John" },
  //   "field-1": { label: "Gender", value: "Male" },
  //   "field-2": { label: "Hobbies", value: ["Reading", "Music"] }
  // }

  const handleSubmit = async () => {

    for (const field of parsedData.fields) {
      const fieldName = `field-${parsedData.fields.indexOf(field)}`;
      if (field.required && !responses[fieldName]) {
        alert(`Please fill the required field: ${field.label}`);
        setSubmitting(false);
        return;
      }
    }


    setSubmitting(true);
    setSError("");
  
    const formData = new FormData();
    formData.append("form_id", form.id);
    formData.append("lat", location?.lat);
    formData.append("long", location?.long);
    // formData.append("fields", fields);
    // formData.append("fields", JSON.stringify(fields));
    formData.append("fields", JSON.stringify(fieldsRef.current));
  
    Object.entries(responses).forEach(([fieldName, value]) => {
      if (value instanceof File) {
        formData.append(fieldName, value);  // Directly appending files
      } else {
        formData.append(fieldName, value);  // Appending other field data
      }
    });
  
    try {
      const { data } = await axios.post(`${domainUrl}/emy_submit_form`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (data.success) {
        setSuccess(true); //// comment for test
      } else {
        setSError(data.message || "Failed to submit.");
      }
    } catch (err) {
      setSError("An error occurred.");
    } finally {
      setSubmitting(false);
    }
  };

  
  if (success) return (
    <>
      <Header page={'form'} subpage={true}/>

      <div className="container-fluid contact py-5">
        <div className="container py-5">
            <div className="row g-5">

                <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                    <div className="form-section bg-success p-5 h-100">
                      <div className="text-center">
                        <h1 className="display-4 text-white mb-4">🎉 Form submitted successfully!</h1>
                      </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <Footer subpage={true}/>
    </>
  );

  if (loading) return (
    <>
      <Header page={'form'} subpage={true}/>

      <div className="container-fluid contact py-5">
        <div className="container py-5">
            <div className="row g-5">

                <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                    <div className="form-section bg-success p-5 h-100">
                      <div className="text-center">
                        <h1 className="display-4 text-white mb-4">Loading Form...</h1>
                      </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <Footer subpage={true}/>
    </>
  );

  if (error) return (
    
    <>
        <Header page={'form'} subpage={true}/>

        <div className="container-fluid contact py-5">
          <div className="container py-5">
              <div className="row g-5">

                  <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                      <div className="form-section bg-success p-5 h-100">
                        <div className="text-center">
                          <h1 className="display-4 text-white mb-4">{error}</h1>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>

        <Footer subpage={true}/>
      </>
  );

  if (keyRequired) {
    return (

      <>
        <Header page={'form'} subpage={true}/>

          <div className="container-fluid contact py-5">
            <div className="container py-5">
                <div className="row g-5">

                    <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                        <div className="form-section bg-success p-5 h-100">


                          <div className="text-center">
                            <h1 className="display-4 text-white mb-4">🔒 Private Form</h1>
                            <p className="text-white">Please enter the Access Key to view this form:</p>

                            <div className="col-6 mx-auto">
                              <div className="form-floating form-section-col">
                                <input 
                                  type="text" 
                                  value={accessKey} 
                                  onChange={(e) => setAccessKey(e.target.value)} 
                                  // className="form-control" 
                                  className="form-control col-4"
                                />
                              </div>
                            </div>

                            
                            <button onClick={handleSubmitKey} className="btn btn-primary mt-3">Submit Key</button>
                          </div>
                            
                          
                        </div>
                    </div>
                </div>
            </div>
          </div>

        <Footer subpage={true}/>
      </>
    );
  }

  return (
    
    <>
      <Header page={'form'} subpage={true}/>

      <div className="container-fluid contact py-5">
        <div className="container py-5">
            <div className="row g-5">

                <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                    <div className="form-section bg-success p-5 h-100">
                        
                      <h1 className="display-4 text-white mb-4">{form.name}</h1>

                      <div>
                        <div className="row g-4">
                          {/* {parsedData.fields.map((field, idx) => (
                            <div key={idx} className="col-lg-12 col-xl-6">
                              <div className="form-floating form-section-col text-white">
                                {renderField(field, idx)}
                                <label htmlFor={`field-${idx}`}>{field.label}</label>
                              </div>
                            </div>
                          ))} */}

                          {/* {parsedData.fields.map((field, idx) => (
                            <div key={idx} className="col-lg-12 col-xl-6">
                              {['radio', 'checkbox'].includes(field.type) ? (
                                <div className="mb-3">
                                  {renderField(field, idx)}
                                </div>
                              ) : (
                                <div className="form-floating form-section-col">
                                  {renderField(field, idx)}
                                  <label htmlFor={`field-${idx}`}>{field.label}</label>
                                </div>
                              )}
                            </div>
                          ))} */}

                          {parsedData.fields.map((field, idx) => (
                            <div key={idx} className="col-lg-12 col-xl-6">
                              {['radio', 'checkbox'].includes(field.type) ? (
                                <div className="mb-3 text-white">
                                  {/* Show the main label/question manually on top */}
                                  <label className="form-label mb-2" htmlFor={`field-${idx}`}>
                                    {field.label} {field.required && <span className="text-danger">*</span>}
                                  </label>
                                  {renderField(field, idx)}
                                </div>
                              ) : (
                                <div className="form-floating form-section-col">
                                  {renderField(field, idx)}
                                  <label htmlFor={`field-${idx}`}>
                                    {field.label} {field.required && <span className="text-danger">*</span>}
                                  </label>
                                </div>
                              )}
                            </div>
                          ))}

                        </div>

                        {sError && <p className="text-danger">{error}</p>}
                        
                        <button onClick={handleSubmit} className="btn btn-primary my-3 mx-auto" disabled={submitting}>
                          {submitting ? "Submitting..." : "Submit Form"}
                        </button>
                      </div>

                    </div>
                </div>
            </div>
        </div>
      </div>

      <Footer subpage={true}/>
    </>

  );
}

export default DataFormViewer;
